import React from 'react';
import { useAuth } from '../../../hooks/auth';
import { useOnboarding, TutorialId } from '../../../hooks/onboarding';
import { QuestionMarkIcon } from '../../../assets/svg/SVGComponents';
import { TutorialButtonContainer } from './styles';

interface SectionTutorialButtonProps {
  /** Qual tutorial iniciar ao clicar */
  tutorialId: TutorialId;
  /** Tamanho do ícone (default: 0.875rem) */
  iconSize?: string;
}

/**
 * Botão de ajuda (?) que aparece no título de cada seção.
 * Ao clicar, inicia o tutorial correspondente àquela seção.
 *
 * Uso:
 * ```tsx
 * <h1>
 *   Home
 *   <SectionTutorialButton tutorialId={TutorialId.HOME} />
 * </h1>
 * ```
 */
const SectionTutorialButton: React.FC<SectionTutorialButtonProps> = ({
  tutorialId: tutorial_id,
}) => {
  const { user } = useAuth();
  const { startTutorial, isOnboardingActive } = useOnboarding();

  // Não renderizar se não há usuário logado ou se um tutorial já está ativo
  if (!user || isOnboardingActive) return null;

  const handleClick = (): void => {
    startTutorial(tutorial_id);
  };

  return (
    <TutorialButtonContainer
      onClick={handleClick}
      type="button"
      title="Iniciar tutorial desta seção"
      aria-label="Iniciar tutorial"
    >
      <QuestionMarkIcon
        stroke="#1e88e5"
        fill="none"
        strokeWidth={2}
        width="1.2rem"
        height="1.2rem"
      />
    </TutorialButtonContainer>
  );
};

export default SectionTutorialButton;
